import React, { useContext, useState, useEffect } from 'react'
import {
  ModalDialog,
  Button,
  UploadScholarshipsModal,
  DownloadScholarshipsModal,
  BackdropLoader,
  CustomLinks,
} from 'components'
import styled, { css } from 'styled-components'
import { I18nContext } from 'i18n'
import { useProgram } from 'hooks/useProgram'
import moment from 'moment'
import { saveAs } from 'file-saver'

const PreUploadModal = ({ show, onHide, setShow, getStagedCount }) => {
  const [showUpload, setShowUpload] = useState(false)
  const [showDownload, setShowDownload] = useState(false)
  const { translate } = useContext(I18nContext)
  const { setOrgId, dataDownload, loadingDownload, orgId, executeDownload } = useProgram()

  useEffect(() => {
    if (dataDownload) {
      const date = `${moment().format('MMDDYYYY')}-${moment().unix()}`
      let blob = new Blob([dataDownload], {
        type: 'text/csv;charset=utf-8',
      })
      saveAs(blob, `scholarships-${date}.csv`)
      setShow(false)
    }
  }, [dataDownload])

  const handleClick = () => {
    setShow(false)
    setShowUpload(true)
  }

  const handleDownload = () => {
    setShow(false)
    setShowDownload(true)
  }

  const handleTemplate = () => {
    setShow(false)
    //Make the org 0 to return an empty file
    orgId === 0 ? executeDownload() : setOrgId(0)
  }

  const subtitle = (
    <div className="px-3 small-font font-weight-lighter mt-1">
      <CustomLinks location="UPLOAD.INFORMATION" />
    </div>
  )

  const handleHideUpload = () => {
    setShowUpload(false)
    getStagedCount()
  }

  return (
    <div>
      <Container
        show={show}
        onHide={onHide}
        title={translate('upload_scholarship_title')}
        size="lg"
        subtitle={subtitle}
        actionButton={
          <ConfirmButton primary="false" className="mr-2" onClick={handleClick}>
            {translate('upload_get_started')}
          </ConfirmButton>
        }
      >
        <div>
          <h5 className="font-weight-bold">
            {`${translate('upload_pre_title')}`}
          </h5>
          <div className="font-weight-bold h6 mt-4">
            {translate('upload_pre_why_upload')}
          </div>
          <div className="font-weight-light">
            {translate('upload_pre_upload_desc')}
          </div>
          <div className="font-weight-bold h6 mt-4">
            {translate('upload_pre_not_worry')}
          </div>
          <div className="font-weight-light">
            {translate('upload_pre_not_worry_desc')}
          </div>
          <div className="font-weight-bold h6 mt-4">
            {translate('upload_pre_ready')}
          </div>
          <div className="font-weight-light">
            {translate('upload_pre_ready_desc')}
            <LinkButton onClick={handleDownload}>
              {translate('upload_download_data')}
            </LinkButton>
            {translate('upload_pre_ready_desc_1')}
            <LinkButton onClick={handleTemplate}>
              {translate('upload_empty_template')}
            </LinkButton>
            {translate('upload_pre_ready_desc_2')}
          </div>
        </div>
      </Container>

      {showUpload && (
        <UploadScholarshipsModal show onHide={handleHideUpload} />
      )}

      {showDownload && (
        <DownloadScholarshipsModal show onHide={() => setShowDownload(false)} />
      )}

      {loadingDownload && <BackdropLoader />}
    </div>
  )
}

const buttonStyle = css`
  background-color: ${({ theme }) => theme.palette.primary[3]} !important;
  border-color: ${({ theme }) => theme.palette.primary[2]} !important;
  box-shadow: none;
`

const LinkButton = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.primary[3]};

  &:focus {
    outline: none;
  }
`

const ConfirmButton = styled(Button)`
  ${buttonStyle}

  &:active, &:focus, &:hover {
    ${buttonStyle}
  }
`

const Modal = ({ className, children, ...rest }) => (
  <ModalDialog className={className} {...rest}>
    {children}
  </ModalDialog>
)

const Container = styled(Modal)`
  .modal-content {
    padding: 1rem 2rem;
  }

  .modal-footer {
    > button {
      font-size: 0.9rem;
      min-height: 2.5rem;
    }
  }

  .modal-body {
    background-color: ${({ theme }) => theme.palette.primary[6]} !important;
    color: ${({ theme }) => theme.palette.grayscale[1]};
    border: 2px solid ${({ theme }) => theme.palette.primary[5]} !important;

    > div {
      margin: 0.5rem 1rem;
      font-size: 1rem;
    }
  }
`

export default React.memo(PreUploadModal)
